import { ReactElement } from 'react';
import { EmbeddedCompany } from 'types';
import { BoundState, Breadcrumb } from 'components';
import { usePeriod } from 'modules/reporting/usePeriod';
import { RowType, startColumns, endColumns, boundStateOptions } from './common';
import { CompanyFilterChip, CompanyTitle } from 'modules/core/company/components';
import { UserFilterChip } from 'components/filters/UserFilterChip';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { MonthFilterChip } from 'components/filters/DatePartFilterChip';
import { ReportTable } from 'components/ReportTable';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

type ExpenseRowType = RowType & {
  provider: EmbeddedCompany;
};

const columns: ControlledTableColumns<ExpenseRowType> = [
  ...startColumns,
  flexColumn({
    key: 'provider',
    content: 'Provider',
    cellProps: { className: 'align-middle' },
    render: ({ provider }) => <CompanyTitle {...provider} />,
  }),
  ...endColumns,
  {
    key: 'state',
    configLabel: 'Status',
    width: 30,
    cellProps: {
      className: 'align-middle text-right',
    },
    render: ({ state, is_overspent }) => <BoundState variant="expense" state={state} is_overspent={is_overspent} />,
  },
];

export function ExpenseLinks(): ReactElement {
  const { date_from: minDate, date_to: maxDate } = usePeriod();
  return (
    <ReportTable
      url="invoicing/links/expense"
      columns={columns}
      filterFields={
        <>
          <Breadcrumb>Expense</Breadcrumb>
          <UserFilterChip name="manager" filter={{ manage_campaign: true }} />
          <CompanyFilterChip name="provider" />
          <SelectFilterChip name="state" options={boundStateOptions} />
          <MonthFilterChip name="month" minDate={minDate} maxDate={maxDate} />
        </>
      }
    />
  );
}
